import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HttpRequestProducCodeInterceptor implements HttpInterceptor {
    private OrgChartProductCode: string = 'OrgChart';

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //Get the Product Code From Environment

        const productCodeReq = req.clone({
            headers: req.headers.set('product-code', this.OrgChartProductCode),
        });

        return next.handle(productCodeReq);
    }
}
